<template>
  <div class="v-data-footer">
    <v-row class="pt-5">
      <v-spacer></v-spacer>
      <v-col cols="3">
        <VAutocompleteWithValidation
          v-model="format.type"
          label="Formát exportu"
          outlined
          dense
          background-color="white"
          item-text="text"
          item-value="name"
          :items="formats"
          :loading="formatsLoading"
          :icon="format.type ? 'mdi-close' : 'mdi-none'"
          @click:prepend="format.type = null"
        />
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="exportSelected"
          :menu-props="{ offsetY: true }"
          outlined
          dense
          label="Export"
          :items="exportTypes"
          item-text="name"
          item-value="value"
          data-cy="exportSelect"
        />
      </v-col>

      <v-col cols="auto">
        <v-btn
          :disabled="disabledExportButton"
          height="40"
          color="primary"
          :loading="exportLoading"
          depressed
          @click="exportData($event)"
        >
          Export
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import requestUrlFunction from '@/utils/requestUrl'
import { downloadFile } from '../mixins/downloadFile'
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'

export default {
  name: 'OrdersExportFooter',
  components: { VAutocompleteWithValidation },
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exportSelected: null,
      exportLoading: false,
      formats: [],
      formatsLoading: false,
      format: {
        type: null,
      },
    }
  },
  computed: {
    exportTypes() {
      return [
        {
          name: 'Exportovat zobrazená data',
          value: 'showedData',
        },
        {
          name: 'Exportovat vybraná data',
          value: 'selectedData',
          disabled: !this.selectedIds.length,
        },
        {
          name: 'Exportovat všechna data',
          value: 'allData',
        },
      ]
    },
    selectedIds() {
      return this.value.selectedData.items.map((item) => item.id)
    },
    failedIds() {
      return this.value.selectedData.items.filter(
        (item) => item.status.name !== 'NEW' && item.status.name !== 'PROCESSING'
      )
    },
    disabledExportButton() {
      if (!this.exportSelected) {
        return true
      }
      if (this.exportSelected === 'selectedData' && !this.selectedIds.length) {
        return true
      }
      return false
    },
  },
  created() {
    this.loadOrderExportFormats()
  },
  methods: {
    ...mapActions({
      getOrderExportFormats: 'enum/listOrderExportFormat',
    }),
    exportData(event) {
      this.exportLoading = true

      if (this.exportSelected === 'showedData') {
        this.downloadFile(
          event,
          this.format.type == null
            ? `order/export${requestUrlFunction(this.value.selectedData.params)}`
            : `order/export${requestUrlFunction(this.value.selectedData.params)}&format=${
                this.format.type
              }`
        ).finally(() => {
          this.exportLoading = false
        })
      } else if (this.exportSelected === 'selectedData') {
        const ids = this.value.selectedData.items.map((item) => item.id).join('&ids=')

        this.downloadFile(
          event,
          this.format.type == null
            ? `order/export?ids=${ids}`
            : `order/export?ids=${ids}&format=${this.format.type}`
        ).finally(() => {
          this.exportLoading = false
        })
      } else if (this.exportSelected === 'allData') {
        this.downloadFile(
          event,
          this.format.type == null
            ? `order/export${requestUrlFunction(
                this.value.selectedData.params,
                this.value.totalElements
              )}`
            : `order/export${requestUrlFunction(
                this.value.selectedData.params,
                this.value.totalElements
              )}&format=${this.format.type}`
        ).finally(() => {
          this.exportLoading = false
        })
      }
    },
    loadOrderExportFormats() {
      this.formatsLoading = true
      this.getOrderExportFormats()
        .then((response) => {
          this.formats = response.data
        })
        .finally(() => {
          this.formatsLoading = false
        })
    },
  },
}
</script>
